const arrayToMap = (array, attr, where) => {
  const result = {};
  array.forEach(item => {
    if (where) {
      if (where(item)) {
        result[item[attr]] = item;
      }
    } else {
      result[item[attr]] = item;
    }
  });

  return result;
};

export default arrayToMap;
